import { useEffect, useState, useRef } from "react";
import styled, { useTheme } from "styled-components";
import { observer, inject } from "mobx-react";
import logoutImg from "../assets/img/logout.svg";
import alertImg from "../assets/img/alert_icon.svg";
import alertFullImg from "../assets/img/alert_full_icon.svg";
import badgeImg from "../assets/img/badge_circle.svg";

import { useNavigate } from "react-router-dom";
import { Text } from "../UI";
import { CircleDiv } from "../components/Common";
import DropDownMenu from "../UI/DropDownMenu";
import navigateImg from "../assets/img/outline-keyboard_arrow_left.svg";
import { Role } from "../stores/userStore";
import { auth } from "../config/firebase";
import { signOut } from "firebase/auth";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import RepairMessageList from "../components/RepairMessageList";


const Menu = styled("div")(({ theme, isRtl }) => ({
  position: "absolute",
  transform: "translateY(15px)",
  overflow: "auto",
  backgroundColor: "#fff",
  padding: 10,
  color: theme.color.text,
  zIndex: 9999,
  boxShadow: `0px 4px 20px #C3C0D3`,
  borderRadius: 18,
  top: 65,
  left: isRtl ? 95 : "unset",
  right: isRtl ? "unset" : 95,

}));

const DropDownItem = styled("div")(({ theme, selected, }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  cursor: "pointer",
  height: 40,
  backgroundColor: selected ? theme.color.background : "unset",

  ":hover": {
    borderRadius: 20,
    backgroundColor: theme.color.gray10,
  },
}));

const Header = ({ userStore, tenantsStore, repairPagesStore, title, project, admin }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation("menu");
  const isRtl = i18n.dir() === "rtl";
  const langMenu = useRef();
  const messageMenu = useRef();

  const [showLangMenu, setShowLangMenu] = useState(false);
  const [showMessageMenu, setShowMessageMenu] = useState(false);
  const changeLanguageHandler = (lang) => {
    userStore.setLanguage(lang);
    setShowLangMenu(false);
  };

  const [newMessages, setNewMessages] = useState([])

  useEffect(() => {
    const allNewRepairMessages = repairPagesStore.allRepairMessages?.filter((msg) => msg.ISTENANT !== "Y" && msg.ISNEW === "Y")?.map(msg => ({ ...msg, REPAIRMSG: true })) || [];
    const allNewMessages = tenantsStore.allMessages?.filter((msg) => msg.WASREADFLAG !== "Y") || [];
    setNewMessages([...allNewRepairMessages, ...allNewMessages]);
  }, [repairPagesStore.allRepairMessages, tenantsStore.allMessages])


  useEffect(() => {
    const fetchData = async () => {
      const data = {
        CUST: userStore.userDetails.CUST,
        DNAME: tenantsStore.selectedSiteSpace?.DNAME,
        ENV: tenantsStore.selectedSiteSpace?.DNAME,
        SPACENAME: tenantsStore.selectedSiteSpace?.SPACENAME
      }


      const repairs = await repairPagesStore.getConversationMessages(data)

      const repairsMessages = repairs?.map(rep => (rep.ZCOB_TENANTCONV_SUBFORM?.map(msg => ({
        ...msg, REPAIRNAME: rep.REPAIRNAME
      })) || [])).flat() || [];

      const newMessages = repairsMessages?.filter((msg) => msg.ISNEW === "Y" && msg.ISTENANT !== "Y")
        ?.map(msg => ({ ...msg, REPAIRMSG: true }))

      const project = tenantsStore.sites?.find(
        (s) => s.SITENUM === tenantsStore.selectedSiteSpace?.SITENUM && s.DNAME === tenantsStore.selectedSiteSpace?.DNAME
      );

      let messages = []
      if (tenantsStore.selectedSiteSpace?.CONTSALE === "Y" &&
        tenantsStore.selectedSiteSpace?.ISONLYBEDEK !== "Y" &&
        project?.BEDEK !== "Y") {

        const bodyData = {
          MAINCUST: userStore.userDetails.MAINCUST,
          CUST: userStore.userDetails.CUST,
          MAINENV: userStore.userDetails.MAINENV,
          CUSTNAME: userStore.userDetails?.CUSTNAME,
          SITEID: tenantsStore.selectedContract?.SITEID,
          BUILDINGNUM: tenantsStore.selectedContract?.BUILDINGNUM,
          CONTNAME: tenantsStore.selectedContract?.CONTNAME,
          DNAME:
            tenantsStore.selectedContract?.DNAME ||
            tenantsStore.selectedSiteSpace?.DNAME,
        };
        messages = await tenantsStore.getSaleContractMessages(bodyData);

      }
      const newContractMessages = messages?.filter((msg) => msg.WASREADFLAG !== "Y") || [];

      const allMessages = [...newMessages, ...newContractMessages]
      setNewMessages(allMessages);

    };
    if (!!tenantsStore.selectedSiteSpace?.SPACENAME) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantsStore.selectedSiteSpace]);

  const handlelLogout = () => {
    const route =
      userStore.userDetails?.role === Role.Tenant
        ? `/tenants/login`
        : `admin/login`;
    userStore.logout();
    tenantsStore.setContracts([]);
    signOut(auth);
    navigate(route);
  };

  useEffect(() => {
    i18n.changeLanguage(userStore.language);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userStore.language]);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (langMenu.current && !langMenu.current.contains(event.target)) {
        setShowLangMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [langMenu]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (messageMenu.current && !messageMenu.current.contains(event.target)) {
        setShowMessageMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [messageMenu]);


  const handleSelectProjectChange = async (value) => {
    const project = tenantsStore.sites?.find(
      (s) => s.SITENUM === value?.SITENUM && s.DNAME === value.DNAME
    );
    const data = {
      ...value,
      SITE: project?.SITE,
      SITEID: project?.SITEID,
    };




    await tenantsStore.setSelectedContract(null);
    if (
      data.SPACENAME !== tenantsStore.selectedSiteSpace?.SPACENAME ||
      data.DNAME !== tenantsStore.selectedSiteSpace?.DNAME
    )
      await tenantsStore.setSelectedSiteSpace(data);

    const bodyData = {
      CUST: userStore.userDetails.CUST,
      DNAME: tenantsStore.selectedSiteSpace?.DNAME,
      ENV: tenantsStore.selectedSiteSpace?.DNAME,
      SPACENAME: tenantsStore.selectedSiteSpace?.SPACENAME
    }


    const repairs = await repairPagesStore.getConversationMessages(bodyData)
    const messages = repairs?.map(rep => rep.ZCOB_TENANTCONV_SUBFORM || []).flat(1) || [];
    const newMessages = messages?.filter((msg) => msg.ISNEW === "Y" && msg.ISTENANT !== "Y")

    setNewMessages(newMessages);


    if (
      tenantsStore.selectedSiteSpace?.CONTSALE !== "Y" ||
      tenantsStore.selectedSiteSpace?.ISONLYBEDEK === "Y" ||
      project?.BEDEK === "Y"
    ) {
      navigate("/bedek/applies");
    } else {
      navigate("/tenant/lobby");
    }
  };






  return (
    <div
      style={{
        display: "flex",
        flexDercrion: "row",
        justifyContent: "space-between",
        backgroundColor: theme.color.white,
        padding: "16px 30px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Text.H4 color={theme.color.red} style={{ textAlign: "start" }}>
          {t(title)}
        </Text.H4>
        {project && (
          <>
            <img src={navigateImg} alt="navigate" />
            <Text.H4 color={theme.color.red} style={{ textAlign: "start" }}>
              {project}
            </Text.H4>
          </>
        )}
      </div>
      <div
        style={{
          display: "flex",
          flexDercrion: "row",
          gap: 14,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {userStore.userDetails.ALL_TENANT_SPACES?.length > 1 && !admin && (
          <DropDownMenu
            style={{ marginTop: 5, marginBottom: 5, }}
            options={userStore.userDetails.ALL_TENANT_SPACES?.map((space) => {
              return {
                value: space,
                label: `${space?.SITEDES} ${space?.SPACEDES}`,
              };
            })}
            onSelect={handleSelectProjectChange}
            value={{
              value: tenantsStore.selectedSiteSpace,
              label: `${tenantsStore.selectedSiteSpace?.SITEDES} ${tenantsStore.selectedSiteSpace?.SPACEDES}`,
            }}
          />
        )}
        <CircleDiv backgroundColor={theme.color.primary}>
          <Text.H4 color={theme.color.white} style={{ textAlign: "center" }}>
            {userStore.userDetails?.NAME?.split(" ")
              .map((n) => n.slice(0, 1))
              .join("")}
          </Text.H4>
        </CircleDiv>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <CircleDiv
            style={{ border: `1px solid ${theme.color.gray30}`, textTransform: "capitalize" }}
            backgroundColor={theme.color.white}
            onClick={() => setShowLangMenu(true)}
          >
            <Text.SM
              color={theme.color.gray90}
              style={{
                textAlign: "center",
              }}
            >
              {t(`login:${userStore.language}`)}
            </Text.SM>
          </CircleDiv>
          {showLangMenu && (
            <Menu style={{ textTransform: "capitalize" }} isRtl={isRtl} ref={langMenu}
            >
              <DropDownItem onClick={() => changeLanguageHandler("he")} style={{ marginBlockEnd: 12 }} >
                <CircleDiv
                  backgroundColor={theme.color.gray30}
                  height={35}
                  width={35}
                  style={{ marginInlineEnd: 10 }}
                >
                  <Text.BM
                    size={16}
                    color={theme.color.gray90}
                    style={{
                      textAlign: "center",
                    }}
                  >
                    {t("login:he")}
                  </Text.BM>
                </CircleDiv>
                {t("login:hebrew")}
              </DropDownItem>
              <DropDownItem onClick={() => changeLanguageHandler("en")} >
                <CircleDiv
                  height={35}
                  width={35}
                  backgroundColor={theme.color.gray30}
                  style={{ marginInlineEnd: 10 }}
                >
                  <Text.BM
                    size={16}
                    color={theme.color.gray90}
                    style={{
                      textAlign: "center",
                    }}
                  >
                    {t("login:en")}
                  </Text.BM>
                </CircleDiv>
                {t("login:english")}
              </DropDownItem>
            </Menu>
          )}
        </div>
        <div style={{ display: "flex", flexDirection: isRtl ? "column" : "column-reverse" }}>
          <CircleDiv onClick={() => setShowMessageMenu(!showMessageMenu && newMessages.length > 0)} style={{
            border: `1px solid ${theme.color.gray30}`,
            backgroundColor: !!showMessageMenu ? theme.color.gray30 : 'transparent'
          }}
          >
            {newMessages.length > 0 && <div
              style={{
                position: "relative",
                mask: `url(${badgeImg}) no-repeat center / contain`,
                backgroundColor: theme.color.primary,
                border: `2px solid ${theme.color.white}`,
                borderRadius: 50,
                width: 10,
                height: 10,
                top: -5,
                left: isRtl ? -11 : 11,
                zIndex: 999
              }}></div>}

            <div
              style={{
                mask: `url(${!showMessageMenu ? alertImg : alertFullImg}) no-repeat center / contain`,
                backgroundColor: theme.color.primary,
                width: 20,
                height: 20,
                marginLeft: newMessages.length > 0 ? (isRtl ? 10 : -10) : 0
              }}></div>
          </CircleDiv>
          {(showMessageMenu && newMessages.length > 0) && (
            <Menu style={{ textTransform: "capitalize" }} isRtl={isRtl} ref={messageMenu}>

              <RepairMessageList
                project={tenantsStore.selectedProject}
                setShowMessageMenu={setShowMessageMenu}
                newMessages={newMessages} />
            </Menu>
          )}
        </div>




        <CircleDiv onClick={handlelLogout} style={{ border: `1px solid ${theme.color.gray30}` }}
        >
          <div
            style={{
              mask: `url(${logoutImg}) no-repeat center / contain`,
              backgroundColor: theme.color.primary,
              width: 20,
              height: 20,
            }}></div>
        </CircleDiv>
      </div>
    </div >
  );
};
export default inject("userStore", "tenantsStore", "repairPagesStore")(observer(Header));
